import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { setUser } from '../store/slices/authSlice';
import { useIsAuthenticated } from '@azure/msal-react';
import { routePermissions } from './routePermissions';
import { fetchCurrentUserProfile } from '../store/slices/userProfileSlice';
import LoadingContainer from '../components/LoadingContainer';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const dispatch = useAppDispatch()
  const isAuthenticated = useIsAuthenticated()
  const currentUser = useAppSelector(state => state.auth.user);
  const userProfile = useAppSelector(state => state.userProfile.data);
  const allowedRoles = routePermissions[location.pathname];

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(setUser());
      dispatch(fetchCurrentUserProfile());
    }
  }, [isAuthenticated, dispatch]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!currentUser || !userProfile) {
    return <LoadingContainer />
  }

  if (allowedRoles && currentUser && !allowedRoles.includes(userProfile.role)) {
    return <Navigate to="/translations" replace />;
  }

  return <>{children}</>;
};


export default ProtectedRoute;
